/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_Plan_CnInputs */

const en_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const ar_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const de_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const es_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const fr_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const it_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const ja_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const ko_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const pt_br_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const ru_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const th_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const tr_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Month`)
};

const zh_cn_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个月`)
};

const zh_tw_monthly_plan_cn = /** @type {(inputs: Monthly_Plan_CnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个月`)
};

/**
* | output |
* | --- |
* | "1 Month" |
*
* @param {Monthly_Plan_CnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_plan_cn = /** @type {((inputs?: Monthly_Plan_CnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Plan_CnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_plan_cn(inputs)
	if (locale === "ar") return ar_monthly_plan_cn(inputs)
	if (locale === "de") return de_monthly_plan_cn(inputs)
	if (locale === "es") return es_monthly_plan_cn(inputs)
	if (locale === "fr") return fr_monthly_plan_cn(inputs)
	if (locale === "it") return it_monthly_plan_cn(inputs)
	if (locale === "ja") return ja_monthly_plan_cn(inputs)
	if (locale === "ko") return ko_monthly_plan_cn(inputs)
	if (locale === "pt_br") return pt_br_monthly_plan_cn(inputs)
	if (locale === "ru") return ru_monthly_plan_cn(inputs)
	if (locale === "th") return th_monthly_plan_cn(inputs)
	if (locale === "tr") return tr_monthly_plan_cn(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_plan_cn(inputs)
	return zh_tw_monthly_plan_cn(inputs)
});